/**
 * ArtGold PDP - artgold-pdp.js  v3.0
 * Vanilla JS only. No framework dependencies.
 * Analytics hooks: Shopify.analytics.publish
 * A/B test points marked with [A/B-TEST: ...]
 */

(function () {
  'use strict';

  // ── HELPERS ──────────────────────────────────────

  function money(cents, currency) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2
    }).format((cents || 0) / 100);
  }

  function publish(event, payload) {
    try {
      if (window.Shopify && Shopify.analytics) {
        Shopify.analytics.publish('artgold_' + event, payload || {});
      }
    } catch (e) {}
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // ── INIT ─────────────────────────────────────────

  function initPDP(root) {
    var dataEl = qs('[id^="AgProductData-"]', root);
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var currency = product.currency || 'USD';
    var scarcityThreshold = parseInt(root.dataset.scarcity, 10) || 3;

    // ── VARIANT STATE ──

    // Collect all option radio inputs
    var optionInputs = qsa('[data-ag-option]', root);

    // Derive selected options array from checked radios
    function selectedOptions() {
      var opts = {};
      optionInputs.forEach(function (inp) {
        if (inp.checked) opts[parseInt(inp.dataset.position, 10)] = inp.value;
      });
      return product.options.map(function (opt) { return opts[opt.position] || null; });
    }

    function findVariant(selections) {
      if (!product.variants.length) return null;
      if (!product.options.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selections[i]; });
      }) || null;
    }

    function updateOptionAvailability(currentSelections) {
      product.options.forEach(function (opt) {
        var pos = opt.position;
        opt.values.forEach(function (val) {
          var test = currentSelections.slice();
          test[pos - 1] = val;
          var avail = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) {
              return !test[i] || o === test[i];
            });
          });
          var inp = qs('[data-ag-option][data-position="' + pos + '"][value="' + CSS.escape(val) + '"]', root);
          if (inp) {
            var pill = inp.closest('.ag-pdp__pill');
            if (pill) pill.classList.toggle('is-soldout', !avail);
          }
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;

      // Update hidden variant IDs in all forms
      qsa('[data-ag-variant-id]', root).forEach(function (inp) {
        inp.value = variant.id;
      });

      // Price
      var priceEl = qs('[data-ag-price]', root);
      if (priceEl) priceEl.textContent = money(variant.price, currency);

      var compareEl = qs('[data-ag-compare]', root);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price, currency);
          compareEl.hidden = false;
          var savingsEl = qs('[data-ag-savings]', root);
          if (savingsEl) {
            savingsEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price, currency);
            savingsEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          var savingsEl2 = qs('[data-ag-savings]', root);
          if (savingsEl2) savingsEl2.hidden = true;
        }
      }

      // Installments
      var instEl = qs('[data-ag-installments]', root);
      if (instEl) {
        if (variant.price >= 20000) {
          instEl.hidden = false;
          var amtEl = qs('[data-ag-installment-amount]', root);
          if (amtEl) amtEl.textContent = money(Math.round(variant.price / 4), currency);
        } else {
          instEl.hidden = true;
        }
      }

      // SKU
      var skuWrap = qs('[data-ag-sku-wrap]', root);
      var skuEl = qs('[data-ag-sku]', root);
      if (skuWrap && skuEl) {
        if (variant.sku) {
          skuWrap.hidden = false;
          skuEl.textContent = variant.sku;
        } else {
          skuWrap.hidden = true;
        }
      }

      // ATC buttons state
      var atcBtns = qsa('[data-ag-atc], [data-ag-sticky-atc]', root);
      atcBtns.forEach(function (btn) {
        btn.disabled = !variant.available;
        var txt = btn.querySelector('[data-ag-atc-text]');
        if (txt) {
          var ctaLabel = 'Unavailable';
          if (variant.available && variant.inventory_quantity === 0 && variant.inventory_policy === 'continue') {
            ctaLabel = 'Crafted to Order';
          } else if (variant.available) {
            ctaLabel = 'Add to Cart';
          }
          txt.textContent = ctaLabel;
        }
      });

      // Scarcity
      var scarcityEl = qs('[data-ag-scarcity]', root);
      if (scarcityEl) {
        var show = variant.inventory_management === 'shopify'
          && variant.inventory_policy === 'deny'
          && variant.inventory_quantity > 0
          && variant.inventory_quantity <= scarcityThreshold;
        scarcityEl.hidden = !show;
      }

      // Back in stock
      var bisEl = qs('[data-ag-bis]', root);
      if (bisEl) bisEl.hidden = variant.available;

      // Availability aria
      var availEl = qs('[data-ag-availability]', root);
      if (availEl) availEl.textContent = !variant.available ? 'Sold Out' : (variant.inventory_quantity > 0 ? 'In Stock' : '');

      // Sticky variant label
      var stickyVariant = qs('[data-ag-sticky-variant]', root);
      if (stickyVariant) {
        stickyVariant.textContent = product.options.length > 0 ? variant.title : '';
      }

      // Sticky price
      var stickyPrice = qs('[data-ag-sticky-price]', root);
      if (stickyPrice) stickyPrice.textContent = money(variant.price, currency);

      // Gallery: switch to variant media
      if (variant.featured_media_id) {
        activateSlide(variant.featured_media_id, root);
        // Update sticky thumb
        var mediaEntry = product.media.find(function (m) { return m.id === variant.featured_media_id; });
        if (mediaEntry) {
          var sThumb = qs('[data-ag-sticky-thumb]', root);
          if (sThumb) sThumb.src = mediaEntry.thumb;
        }
      }

      // URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Finance
      updateFinance(variant.price);

      // Analytics
      publish('variant_change', { variant_id: variant.id, variant_title: variant.title });
    }

    // ── OPTION PILLS ──

    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        var pill = inp.closest('.ag-pdp__pill');
        if (pill) {
          var allPills = qsa('.ag-pdp__pill', inp.closest('.ag-pdp__pills'));
          allPills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
        }
        // Update selected value label
        var group = inp.closest('.ag-pdp__option-group');
        if (group) {
          var valEl = qs('[data-ag-selected-val="' + inp.dataset.position + '"]', root);
          if (valEl) valEl.textContent = ': ' + inp.value;
        }
        var selections = selectedOptions();
        updateOptionAvailability(selections);
        var variant = findVariant(selections);
        if (variant) applyVariant(variant);
      });
    });

    // ── RING SIZE ──
    var ringsizeEl = qs('[data-ag-ringsize]', root);
    if (ringsizeEl) {
      var selectEl = qs('[data-ag-ringsize-select]', ringsizeEl);
      var unitBtns = qsa('[data-ag-unit]', ringsizeEl);
      var hiddenInput = qs('[data-ag-ringsize-input]', root);
      var errorEl = qs('[data-ag-ringsize-error]', ringsizeEl);
      var otherUnitEl = qs('[data-ag-ringsize-other-unit]', ringsizeEl);
      var otherValEl = qs('[data-ag-ringsize-other-val]', ringsizeEl);
      var secondaryUnitEl = qs('[data-ag-ringsize-secondary-unit]', ringsizeEl);
      var secondaryValEl = qs('[data-ag-ringsize-secondary-val]', ringsizeEl);
      var sizeRows = [
        { us:'3', eu:'44', br:'4' },
        { us:'3.5', eu:'45', br:'5' },
        { us:'4', eu:'46', br:'6' },
        { us:'4.5', eu:'47', br:'7' },
        { us:'5', eu:'49', br:'9' },
        { us:'5.5', eu:'50', br:'10' },
        { us:'6', eu:'52', br:'12' },
        { us:'6.5', eu:'53', br:'13' },
        { us:'7', eu:'54', br:'14' },
        { us:'7.5', eu:'56', br:'16' },
        { us:'8', eu:'57', br:'17' },
        { us:'8.5', eu:'58', br:'18' },
        { us:'9', eu:'59', br:'19' },
        { us:'9.5', eu:'61', br:'21' },
        { us:'10', eu:'62', br:'22' },
        { us:'10.5', eu:'63', br:'23' },
        { us:'11', eu:'64', br:'24' },
        { us:'11.5', eu:'66', br:'26' },
        { us:'12', eu:'67', br:'27' },
        { us:'12.5', eu:'68', br:'28' },
        { us:'13', eu:'69', br:'29' },
        { us:'13.5', eu:'70', br:'30' },
        { us:'14', eu:'72', br:'31' },
        { us:'14.5', eu:'73', br:'32' },
        { us:'15', eu:'75', br:'33' }
      ];
      var currentUnit = 'us';

      function renderSizeOptions(unit) {
        if (!selectEl) return;
        var placeholder = '<option value="" disabled selected>Select size</option>';
        var opts = sizeRows.map(function(row) {
          var label = unit.toUpperCase() + ' ' + row[unit];
          return '<option value="' + label + '" data-ag-us="' + row.us + '" data-ag-eu="' + row.eu + '" data-ag-br="' + row.br + '">' + label + '</option>';
        }).join('');
        selectEl.innerHTML = placeholder + opts;
        if (hiddenInput) hiddenInput.value = '';
        if (otherValEl) otherValEl.textContent = '—';
        if (secondaryValEl) secondaryValEl.textContent = '—';
      }

      function updateEquivalents(opt) {
        if (!opt) return;
        if (currentUnit === 'us') {
          if (otherUnitEl) otherUnitEl.textContent = 'EU';
          if (otherValEl) otherValEl.textContent = opt.dataset.agEu || '—';
          if (secondaryUnitEl) secondaryUnitEl.textContent = 'BR';
          if (secondaryValEl) secondaryValEl.textContent = opt.dataset.agBr || '—';
        } else if (currentUnit === 'eu') {
          if (otherUnitEl) otherUnitEl.textContent = 'US';
          if (otherValEl) otherValEl.textContent = opt.dataset.agUs || '—';
          if (secondaryUnitEl) secondaryUnitEl.textContent = 'BR';
          if (secondaryValEl) secondaryValEl.textContent = opt.dataset.agBr || '—';
        } else {
          if (otherUnitEl) otherUnitEl.textContent = 'US';
          if (otherValEl) otherValEl.textContent = opt.dataset.agUs || '—';
          if (secondaryUnitEl) secondaryUnitEl.textContent = 'EU';
          if (secondaryValEl) secondaryValEl.textContent = opt.dataset.agEu || '—';
        }
      }

      unitBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          currentUnit = btn.dataset.agUnit;
          unitBtns.forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          renderSizeOptions(currentUnit);
          if (errorEl) errorEl.hidden = true;
        });
      });

      if (selectEl) {
        renderSizeOptions(currentUnit);
        selectEl.addEventListener('change', function() {
          var selected = selectEl.options[selectEl.selectedIndex];
          if (!selected || !selected.value) return;
          if (hiddenInput) hiddenInput.value = selected.value;
          updateEquivalents(selected);
          if (errorEl) errorEl.hidden = true;
        });
      }
    }

    // ── LETTER PERSONALIZATION ──
    var letterEl = qs('[data-ag-personalize]', root);
    if (letterEl) {
      var letterBtns = qsa('[data-ag-letter]', letterEl);
      var letterInput = qs('[data-ag-letter-input]', root);
      var letterError = qs('[data-ag-letter-error]', letterEl);
      letterBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          letterBtns.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (letterInput) letterInput.value = btn.dataset.agLetter;
          if (letterError) letterError.hidden = true;
        });
      });
    }

    // ── MAKE IT A PAIR ──
    var pairToggle = qs('[data-ag-pair-toggle]', root);
    var pairDetails = qs('[data-ag-pair-details]', root);
    var pairSizeSelect = qs('[data-ag-pair-size-select]', root);
    var pairError = qs('[data-ag-pair-error]', root);
    if (pairToggle && pairDetails) {
      pairToggle.addEventListener('change', function() {
        pairDetails.hidden = !pairToggle.checked;
        if (!pairToggle.checked && pairError) pairError.hidden = true;
      });
    }


    var pairEngravingInput = qs('[data-ag-pair-engraving-input]', root);
    var pairEngravingCount = qs('[data-ag-pair-engraving-count]', root);
    if (pairEngravingInput && pairEngravingCount) {
      pairEngravingInput.addEventListener('input', function() {
        pairEngravingCount.textContent = pairEngravingInput.value.length;
      });
    }
    // ── COMPLEMENTARY ENGRAVING ──
    var engToggle = qs('[data-ag-engraving-toggle]', root);
    var engDetails = qs('[data-ag-engraving-details]', root);
    if (engToggle && engDetails) {
      engToggle.addEventListener('change', function() {
        engDetails.hidden = !engToggle.checked;
      });
    }

    var engDate = qs('[data-ag-engraving-date]', root);
    if (engDate) {
      engDate.addEventListener('input', function() {
        var v = engDate.value.replace(/[^0-9]/g, '');
        if (v.length >= 4) v = v.slice(0,2) + '/' + v.slice(2,4) + '/' + v.slice(4,6);
        else if (v.length >= 2) v = v.slice(0,2) + '/' + v.slice(2);
        engDate.value = v;
      });
    }

    var engName1 = qs('[data-ag-engraving-name1]', root);
    var engName2 = qs('[data-ag-engraving-name2]', root);
    var engSep = qs('[data-ag-engraving-sep]', root);
    var engPreview = qs('[data-ag-engraving-preview]', root);

    function updateEngravingPreview() {
      if (!engPreview) return;
      var n1 = engName1 ? engName1.value.trim() : '';
      var n2 = engName2 ? engName2.value.trim() : '';
      var sep = engSep ? engSep.value : '&';
      if (n1 && n2) {
        engPreview.textContent = n1 + ' ' + sep + ' ' + n2;
      } else if (n1) {
        engPreview.textContent = n1;
      } else if (n2) {
        engPreview.textContent = n2;
      } else {
        engPreview.textContent = 'Your names here';
      }
    }
    if (engName1) engName1.addEventListener('input', updateEngravingPreview);
    if (engName2) engName2.addEventListener('input', updateEngravingPreview);
    if (engSep) engSep.addEventListener('change', updateEngravingPreview);

    // Font selection
    var fontOptions = qsa('[data-ag-font-option]', root);
    var fontMap = {
      'Playball': "'Playball', cursive",
      'Old Standard': "'Old Standard TT', serif",
      'Zen Maru Gothic': "'Zen Maru Gothic', sans-serif",
      'Montserrat': "'Montserrat', sans-serif"
    };
    fontOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        fontOptions.forEach(function(o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var font = opt.dataset.agFontOption;
        if (engPreview) engPreview.style.fontFamily = fontMap[font] || 'inherit';
      });
    });

    // ── PAIR ENGRAVING ──
    var pairEngToggle = qs('[data-ag-pair-engraving-toggle]', root);
    var pairEngDetails = qs('[data-ag-pair-engraving-details]', root);
    if (pairEngToggle && pairEngDetails) {
      pairEngToggle.addEventListener('change', function() {
        pairEngDetails.hidden = !pairEngToggle.checked;
      });
    }

    var pairEngDate = qs('[data-ag-pair-engraving-date]', root);
    if (pairEngDate) {
      pairEngDate.addEventListener('input', function() {
        var v = pairEngDate.value.replace(/[^0-9]/g, '');
        if (v.length >= 4) v = v.slice(0,2) + '/' + v.slice(2,4) + '/' + v.slice(4,6);
        else if (v.length >= 2) v = v.slice(0,2) + '/' + v.slice(2);
        pairEngDate.value = v;
      });
    }

    var pairEngName1 = qs('[data-ag-pair-engraving-name1]', root);
    var pairEngName2 = qs('[data-ag-pair-engraving-name2]', root);
    var pairEngSep = qs('[data-ag-pair-engraving-sep]', root);
    var pairEngPreview = qs('[data-ag-pair-engraving-preview]', root);

    function updatePairEngravingPreview() {
      if (!pairEngPreview) return;
      var n1 = pairEngName1 ? pairEngName1.value.trim() : '';
      var n2 = pairEngName2 ? pairEngName2.value.trim() : '';
      var sep = pairEngSep ? pairEngSep.value : '&';
      if (n1 && n2) pairEngPreview.textContent = n1 + ' ' + sep + ' ' + n2;
      else if (n1) pairEngPreview.textContent = n1;
      else if (n2) pairEngPreview.textContent = n2;
      else pairEngPreview.textContent = 'Your names here';
    }
    if (pairEngName1) pairEngName1.addEventListener('input', updatePairEngravingPreview);
    if (pairEngName2) pairEngName2.addEventListener('input', updatePairEngravingPreview);
    if (pairEngSep) pairEngSep.addEventListener('change', updatePairEngravingPreview);

    var pairFontOptions = qsa('[data-ag-pair-font-option]', root);
    pairFontOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        pairFontOptions.forEach(function(o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var font = opt.dataset.agPairFontOption;
        if (pairEngPreview) pairEngPreview.style.fontFamily = fontMap[font] || 'inherit';
      });
    });

    // ── GALLERY ──

    function activateSlide(mediaId, ctx) {
      var slides = qsa('[data-ag-slide]', ctx || root);
      var thumbs = qsa('[data-ag-thumb]', ctx || root);
      slides.forEach(function (s) {
        s.classList.toggle('is-active', parseInt(s.dataset.mediaId, 10) === mediaId);
      });
      thumbs.forEach(function (t) {
        var isActive = parseInt(t.dataset.mediaId, 10) === mediaId;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    qsa('[data-ag-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateSlide(parseInt(thumb.dataset.mediaId, 10));
      });
    });

    // ── LIGHTBOX ──

    var lightbox = qs('[data-ag-lightbox]', root);
    var lbSlides = lightbox ? qsa('[data-ag-lb-slide]', lightbox) : [];
    var lbImgs = lightbox ? qsa('[data-ag-lb-img]', lightbox) : [];
    var lbCounter = lightbox ? qs('[data-ag-lb-counter]', lightbox) : null;
    var currentLbIdx = 0;
    var lastFocused = null;

    function lbOpen(mediaId) {
      if (!lightbox) return;
      lastFocused = document.activeElement;
      var idx = lbSlides.findIndex(function (s) { return parseInt(s.dataset.mediaId, 10) === mediaId; });
      currentLbIdx = idx >= 0 ? idx : 0;
      lbSetSlide(currentLbIdx);
      lightbox.hidden = false;
      document.body.classList.add('ag-lb-open');
      var closeBtn = qs('[data-ag-lb-close]:not(.ag-lightbox__backdrop)', lightbox);
      if (closeBtn) closeBtn.focus();
      publish('gallery_open', { media_id: mediaId });
    }

    function lbClose() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.classList.remove('ag-lb-open');
      if (lastFocused) lastFocused.focus();
      // Reset zoom
      lbImgs.forEach(function (img) { img.classList.remove('is-zoomed'); });
    }

    function lbSetSlide(idx) {
      currentLbIdx = (idx + lbSlides.length) % lbSlides.length;
      lbSlides.forEach(function (s, i) { s.classList.toggle('is-active', i === currentLbIdx); });
      if (lbCounter) lbCounter.textContent = (currentLbIdx + 1) + ' / ' + lbSlides.length;
    }

    // Open from zoom buttons
    qsa('[data-ag-zoom]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        lbOpen(parseInt(btn.dataset.mediaId, 10));
      });
    });

    // Close
    qsa('[data-ag-lb-close]', root).forEach(function (el) {
      el.addEventListener('click', lbClose);
    });

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.classList.contains('ag-lightbox__backdrop')) lbClose();
      });
    }

    var lbPrev = qs('[data-ag-lb-prev]', root);
    var lbNext = qs('[data-ag-lb-next]', root);
    if (lbPrev) lbPrev.addEventListener('click', function () { lbSetSlide(currentLbIdx - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { lbSetSlide(currentLbIdx + 1); });

    // Zoom inside lightbox
    lbImgs.forEach(function (img) {
      img.addEventListener('click', function (e) {
        var zoomed = img.classList.toggle('is-zoomed');
        if (zoomed) {
          var rect = img.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%';
          var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1) + '%';
          img.style.setProperty('--zoom-x', x);
          img.style.setProperty('--zoom-y', y);
        }
      });
    });

    // Keyboard: ESC close, arrows navigate
    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'Escape') { lbClose(); return; }
      if (e.key === 'ArrowLeft') { lbSetSlide(currentLbIdx - 1); return; }
      if (e.key === 'ArrowRight') { lbSetSlide(currentLbIdx + 1); return; }
    });

    // Focus trap inside lightbox
    if (lightbox) {
      lightbox.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = qsa('button:not([disabled]), [tabindex="0"]', lightbox).filter(function (el) {
          return !el.hidden && el.offsetParent !== null;
        });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    // ── FORM SUBMIT ──

    function submitForm(form) {
      // Ring size validation
      var ringsizeEl = qs('[data-ag-ringsize]', root);
      if (ringsizeEl) {
        var ringsizeInput = qs('[data-ag-ringsize-input]', root);
        var ringsizeError = qs('[data-ag-ringsize-error]', root);
        if (ringsizeInput && !ringsizeInput.value) {
          if (ringsizeError) ringsizeError.hidden = false;
          if (btn) btn.removeAttribute('aria-busy');
          return;
        }
      }

      // Letter validation
      if (letterEl) {
        if (letterInput && !letterInput.value) {
          if (letterError) letterError.hidden = false;
          return;
        }
      }

      var btn = qs('button[type="submit"]', form);
      if (btn) btn.setAttribute('aria-busy', 'true');

      var formData = new FormData(form);
      publish('add_to_cart_click', { variant_id: formData.get('id') });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart error');
          return r.json();
        })
        .then(function (item) {
          // If "Make it a Pair" is checked, add second item with partner's size
          if (pairToggle && pairToggle.checked) {
            var pairSize = pairSizeSelect ? pairSizeSelect.value : '';
            if (!pairSize) {
              if (pairError) pairError.hidden = false;
              return;
            }
            var pairData = new FormData();
            pairData.append('id', formData.get('id'));
            pairData.append('quantity', 1);
            pairData.append('properties[Ring Size]', pairSize);
            pairData.append('properties[Pair]', 'Partner Band');
            var engravingVal = formData.get('properties[Engraving]');
            var dateVal = formData.get('properties[Date]');
            if (engravingVal) pairData.append('properties[Engraving]', engravingVal);
            if (dateVal) pairData.append('properties[Date]', dateVal);
            var pairEngravingVal = pairEngravingInput ? pairEngravingInput.value : '';
            if (pairEngravingVal) pairData.append('properties[Partner Engraving]', pairEngravingVal);
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: pairData
            });
          }
        })
        .then(function() {
          showToast();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          if (form.id === 'AgForm-' + root.dataset.sectionId) {
            form.submit();
          }
        })
        .finally(function () {
          if (btn) btn.removeAttribute('aria-busy');
        });
    }

    qsa('form[data-type="add-to-cart-form"]', root).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitForm(form);
      });
    });

    // Buy Now
    var buyNowBtn = qs('[data-ag-buynow]', root);
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        publish('buy_now_click', {});
        // Submit main form then redirect to checkout
        var mainForm = qs('#AgForm-' + root.dataset.sectionId, root);
        if (!mainForm) return;
        var formData = new FormData(mainForm);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          window.location.href = '/checkout';
        });
      });
    }

    // ── CART TOAST ──

    var toast = qs('[data-ag-toast]', root);
    var toastTimer = null;

    function showToast() {
      if (!toast) return;
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 300);
      }, 3200);
    }

    // ── BACK IN STOCK ──

    var bisSubmit = qs('[data-ag-bis-submit]', root);
    if (bisSubmit) {
      bisSubmit.addEventListener('click', function () {
        var emailEl = qs('[data-ag-bis-email]', root);
        if (!emailEl || !emailEl.value || !emailEl.validity.valid) {
          emailEl && emailEl.focus();
          return;
        }
        publish('email_capture_submit', { email: emailEl.value });
        var successEl = qs('[data-ag-bis-success]', root);
        if (successEl) { successEl.hidden = false; }
        bisSubmit.disabled = true;
        emailEl.disabled = true;
      });
    }

    // ── FINANCING CALCULATOR ──

    var financeBlock = qs('[data-ag-finance]', root);
    var financeToggle = qs('[data-ag-finance-toggle]', root);
    var financeBody = qs('[data-ag-finance-body]', root);
    var financeGrid = qs('[data-ag-finance-grid]', root);
    var financeLow = qs('[data-ag-finance-low]', root);

    var providers = [
      { name: 'Affirm', months: 12, type: 'financing' },
      { name: 'Synchrony', months: 24, type: 'financing' },
      { name: 'Acima', months: 12, type: 'lease' }
    ];

    function updateFinance(priceCents) {
      if (!financeBlock) return;
      if (priceCents < 20000) { financeBlock.hidden = true; return; }
      financeBlock.hidden = false;
      var priceUsd = priceCents / 100;
      var lowest = Infinity;
      var cards = '';
      providers.forEach(function (p) {
        var monthly = priceUsd / p.months;
        if (monthly < lowest) lowest = monthly;
        cards += '<div class="ag-pdp__finance-card">'
          + '<span class="ag-pdp__finance-provider">' + p.name + '</span>'
          + '<span class="ag-pdp__finance-amount">' + money(Math.ceil(monthly * 100), currency) + '</span>'
          + '<span class="ag-pdp__finance-term">' + p.months + ' mo · ' + p.type + '</span>'
          + '</div>';
      });
      if (financeGrid) financeGrid.innerHTML = cards;
      if (financeLow) financeLow.textContent = money(Math.ceil(lowest * 100), currency);
    }

    if (financeToggle && financeBody) {
      financeToggle.addEventListener('click', function () {
        var expanded = financeToggle.getAttribute('aria-expanded') === 'true';
        financeToggle.setAttribute('aria-expanded', String(!expanded));
        financeBody.hidden = expanded;
      });
    }

    // ── ACCORDIONS ──

    qsa('.ag-accordion__btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bodyId = btn.getAttribute('aria-controls');
        var body = qs('#' + bodyId, root);
        if (!body) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              body.style.maxHeight = '0';
              body.classList.remove('is-open');
            });
          });
          setTimeout(function () { body.hidden = true; }, 400);
        } else {
          body.hidden = false;
          body.style.maxHeight = '0';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              body.style.maxHeight = body.scrollHeight + 'px';
              body.classList.add('is-open');
            });
          });
        }
      });
    });

    // ── STICKY ATC ──

    var stickyBar = qs('[data-ag-sticky]', root);
    var ctaAnchor = qs('[data-ag-cta-anchor]', root);

    if (stickyBar && ctaAnchor && 'IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { rootMargin: '0px 0px -100px 0px' });
      stickyObs.observe(ctaAnchor);
    }

    // ── CROSS-SELL ──

    var crosssell = qs('[data-ag-crosssell]', root);
    if (crosssell) {
      var grid = qs('[data-ag-crosssell-grid]', crosssell);
      var limit = parseInt(crosssell.dataset.limit, 10) || 4;
      var pid = crosssell.dataset.productId;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          if (!products.length || !grid) { crosssell.hidden = true; return; }
          grid.innerHTML = products.map(function (p) {
            var img = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + (p.title || '') + '" loading="lazy">'
              : '';
            return '<div class="ag-cs-card" data-product-url="' + (p.url || '') + '">'
              + '<div class="ag-cs-card__img-wrap">'
              + '<a href="' + p.url + '">' + img + '</a>'
              + '<div class="ag-cs-card__actions">'
              + '<button type="button" class="ag-cs-card__btn" data-ag-cs-add>Quick Add</button>'
              + '</div>'
              + '</div>'
              + '<div class="ag-cs-card__meta">'
              + '<a href="' + p.url + '">'
              + '<p class="ag-cs-card__title">' + (p.title || '') + '</p>'
              + '</a>'
              + '<p class="ag-cs-card__price">' + money(p.price, currency) + '</p>'
              + '</div>'
              + '</div>';
          }).join('');

          qsa('[data-ag-cs-add]', grid).forEach(function (btn) {
            btn.addEventListener('click', function () {
              var card = btn.closest('.ag-cs-card');
              var productUrl = card && card.dataset.productUrl;
              if (!productUrl) return;
              var original = btn.textContent;
              btn.disabled = true;
              btn.textContent = 'Adding...';
              fetch(productUrl.replace(/\/$/, '') + '.js')
                .then(function (r) { return r.json(); })
                .then(function (p) {
                  var variant = (p.variants || []).find(function (v) { return v.available; }) || (p.variants || [])[0];
                  if (!variant) throw new Error('No variant');
                  return fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
                    body: 'id=' + encodeURIComponent(variant.id) + '&quantity=1'
                  });
                })
                .then(function (r) { return r.json(); })
                .then(function () {
                  btn.textContent = 'Added';
                  btn.classList.add('is-added');
                  showToast();
                  setTimeout(function () {
                    btn.disabled = false;
                    btn.textContent = original;
                    btn.classList.remove('is-added');
                  }, 1800);
                })
                .catch(function () {
                  btn.disabled = false;
                  btn.textContent = original;
                });
            });
          });
        })
        .catch(function () { crosssell.hidden = true; });
    }

    // ── INIT CURRENT VARIANT ──

    var initSelections = selectedOptions();
    updateOptionAvailability(initSelections);
    var initVariant = findVariant(initSelections) || product.variants[0];
    if (initVariant) applyVariant(initVariant);

    // ── ANALYTICS: PDP VIEW ──

    publish('pdp_view', { product_id: product.id, product_title: product.title });
  }

  // ── BOOT ──

  document.querySelectorAll('[id^="AgPDP-"]').forEach(initPDP);

})();